import { familyApi } from "apiClient/v2";
import { Condition } from "constants/family";
import { FamilyInstanceDTO } from "interfaces/dtos/familyInstance";
import { Family } from "interfaces/models/family";
import { FamilyInstance } from "interfaces/models/familyInstance";
import { GenerateDataType } from "interfaces/models/generateData";
import ForgeDataImporter, { ForgeDataImporterProps } from ".";

class FamilyInstancePositionImporter extends ForgeDataImporter<
  Record<string, FamilyInstanceDTO>
> {
  dataType = GenerateDataType.FAMILY_INSTANCE_POSITION;

  constructor(props: ForgeDataImporterProps) {
    super(props);

    if (props.level) {
      this.dataType = GenerateDataType.FAMILY_INSTANCE_LEVEL;
    }
  }

  private getObjectTypesOfFamilyInstance(
    instance: FamilyInstance,
    families: Family[]
  ) {
    return families.filter((family) => {
      return family.conditions.every((condition) => {
        const attribute =
          condition.attribute === "family" ? "typeName" : condition.attribute;
        const value = String((instance as any)[attribute] || "").toUpperCase();
        const conditionValue = (condition.value || "").toUpperCase();
        switch (condition.condition) {
          case Condition.Contains:
            return !!value && value.includes(conditionValue);
          case Condition.Equal:
            return !!value && value === conditionValue;
          case Condition.Exists:
            return !!value;
          case Condition.Greater:
            return !!value && value > conditionValue;
          case Condition.GreaterOrEqual:
            return !!value && value >= conditionValue;
          case Condition.Less:
            return !!value && value < conditionValue;
          case Condition.LessOrEqual:
            return !!value && value <= conditionValue;
          case Condition.NotContains:
            return !!value && !value.includes(conditionValue);
          case Condition.NotEqual:
            return !!value && value !== conditionValue;
          case Condition.NotExists:
            return !value;
          default:
            return false;
        }
      });
    });
  }

  async normalizeData(
    _data: { [externalId: string]: FamilyInstanceDTO }[]
  ): Promise<Record<string, FamilyInstanceDTO>> {
    const resFamilies = await familyApi.getFamilyList();
    const families = resFamilies?.data || [];

    const mapFamilyInstance: Record<string, FamilyInstanceDTO> = {};
    _data.forEach((item) => {
      Object.keys(item).forEach((externalId) => {
        const instance = item[externalId];
        instance.objectTypes = this.getObjectTypesOfFamilyInstance(
          instance,
          families
        );

        mapFamilyInstance[externalId] = instance;
      });
    });

    return Promise.resolve(mapFamilyInstance);
  }
}

export default FamilyInstancePositionImporter;
